import React from "react";
import logo from "../../assets/images/Coca-Cola.png";
import { Box, Typography } from "@mui/material";
function Logo() {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        gap: '0.75rem', // gap-x-3
        alignItems: 'center',
        paddingLeft: '5rem', // pl-20
        padding: '0.5rem',   // p-2
        marginRight: '1rem', // mr-4
      }}
    >
      <Box
        component="img"
        src={logo}
        alt="Coca Coal MixCodes"
        sx={{
          objectFit: 'scale-down',
          height: '3rem', // h-12
          width: '6rem',  // w-24
        }}
      />
      <Typography
        sx={{
          fontWeight: 800, // font-extrabold
          fontSize: '1.25rem', // text-xl
          color: '#0f172a', // text-slate-950
        }}
      >
        Mix Codes
      </Typography>
    </Box>
  );
}

export default Logo;
